import React from 'react';
import { getConsentItems } from '../../shared/siteParams';

// Список чекбоксов «согласие на обработку ПД» и т.п. (site_consent_checkboxes
// в админке). Аналог `renderConsents()` в `website_default/.../login_*`.
//
// Стейт хранит сам родитель (форма логина) — этот компонент презентационный.
// Использование:
//   const helpers = makeConsentsHelpers(this);
//   { helpers.render() }
//   <button disabled={!helpers.ok() || sending}>...</button>

export function makeConsentsHelpers(component) {
  const items = getConsentItems();

  function isAgreed(idx) {
    const st = component.state.agrees || {};
    if (st[idx] === undefined) return !!(items[idx] && items[idx].default_checked);
    return st[idx] === true;
  }

  function toggle(idx) {
    const next = !isAgreed(idx);
    component.setState((ps) => ({ agrees: Object.assign({}, ps.agrees || {}, { [idx]: next }) }));
  }

  function ok() {
    return items.every((it, idx) => !it.is_required || isAgreed(idx));
  }

  function render() {
    if (!items.length) return null;
    return (
      <div className="ng-consents">
        {items.map((item, idx) => (
          <label key={idx} className="ng-consent">
            <input
              type="checkbox"
              checked={isAgreed(idx)}
              onChange={() => toggle(idx)}
            />
            <span className="ng-consent__text">
              {item.text}
              {item.link_title && item.link_url && (
                <span>
                  {' '}
                  <a
                    href={item.link_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {item.link_title}
                  </a>
                </span>
              )}
            </span>
          </label>
        ))}
      </div>
    );
  }

  return { render, ok, isAgreed, toggle };
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Auth/Consents.jsx